export enum PortalModeType {
  BROKER = 'Wholesale',
  MINI_CORRESPONDENT = 'Non-delegated',
  CORRESPONDENT = 'Delegated'
}